export const token = {
  used: false,
  valid_until: null,
  resend: {
    remaining_attempts: null,
    blocked_until: null,
  },
};
